import {BaseFilter} from './base.filter';

export class UserFilter extends BaseFilter {
  locationId: string;
  searchTerm: string;
  roleId: string;
  active: boolean;
}
